import React , { FC } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";

interface ManageButtonProps {
    onClick: () => void;
    className?: string;
}

const ManageButton: FC<ManageButtonProps> = ({ onClick, className = 'flex ml-8 px-4 bg-lime rounded-lg shadow text-white text-sm items-center' }) => {
    const { translate } = useLocale();
    return <button
            id="manageButton"
            type="button"
            className={className}
            onClick={onClick}>{translate.byKey(TranslationKeys.manage)}</button>
};

export default ManageButton;
